import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import Glyphicon from "../Glyphicon";

class OpisWyjazduMiejsce extends PureComponent<any> {
  static contextType = AppContext;

  handleClick = () => {
    const { id } = this.props;
    const { showInfoWindow } = this.context;
    showInfoWindow("place", id);
  };

  render() {
    const { id } = this.props;
    const { places } = this.context;
    const place = places.filter((place: any) => place.id === id)[0];
    const name = place.name;
    return (
      <span>
        <button
          className="OpisWyjazduMiejsce_button"
          title={"Zobacz kartę miejsca " + name}
          onClick={this.handleClick}
        >
          {name}
        </button>
        {place.galleries &&
          place.galleries.map((gallery: any) => (
            <a
              key={gallery.link}
              className="OpisWyjazduMiejsce_button"
              title={
                !!gallery.tittle
                  ? gallery.tittle
                  : "Zobacz galerię" +
                    (!!gallery.source ? " " + gallery.source : "")
              }
              href={gallery.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Glyphicon
                className="OpisWyjazduMiejsce_icon"
                icon="photo_camera"
              />
            </a>
          ))}
        {place.guides &&
          place.guides.map((guide: any) => (
            <a
              key={guide.link}
              className="OpisWyjazduMiejsce_button"
              title="Zobacz przewodnik"
              href={guide.link}
            >
              <Glyphicon className="OpisWyjazduMiejsce_icon" icon="explore" />
            </a>
          ))}
      </span>
    );
  }
}

export default OpisWyjazduMiejsce;
